import { ReactNode } from "react";
import { EChoiceDisplayValues } from "./EChoiceDisplayValues";
import { useStyle } from "./style";
import { cls } from "itsf-ui-common";
import { Box } from "@mui/material";
import { LabeledButton } from "@common/LabeledButton/LabeledButton";

interface IOption {
    label: ReactNode | string;
    value: EChoiceDisplayValues;
    component?: ReactNode;
    disabled?: boolean;
}

interface IParams {
    selectedChoice: EChoiceDisplayValues;
    setSelectedChoice: (choice: EChoiceDisplayValues) => void;
    options: IOption[];
}

export const ChoiceDisplay = (props: IParams) => {
    const { options, selectedChoice, setSelectedChoice } = props;
    const { classes } = useStyle();

    const styleButton = (isSelected: boolean) => cls(classes.button, isSelected ? classes.selected : undefined);

    const orderedOptions = options.sort((optionA, optionB) => parseInt(optionA.value) - parseInt(optionB.value));
    const displayedComponent = orderedOptions.find((option) => option.value === selectedChoice)?.component;

    return (
        <>
            <div className={classes.buttonsGroup}>
                {orderedOptions.map((option) => (
                    <LabeledButton
                        className={styleButton(option.value === selectedChoice)}
                        color="primary"
                        disableFullWidth
                        disabled={option.disabled}
                        key={option.value}
                        labelText={option.value}
                        variant="outlined"
                        onClick={() => setSelectedChoice(option.value)}
                    >
                        {option.label}
                    </LabeledButton>
                ))}
            </div>
            {displayedComponent && <Box mt={3}>{displayedComponent}</Box>}
        </>
    );
};
